import { client } from "./client";
import interceptors from "./interceptors";
import qs from 'qs';

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getSO(params) {
	return client.get("api/so/data", {
		params: params,
	});
}

function getSOAnually(params) {
	return client.get("api/so/data-annually", {
		params: params,
	});
}

function getSOAll(params) {
	return client.get("api/so/all", {
		params: params,
	});
}

function getSORoam(params) {
	return client.get("api/so/roam", {
		params: params,
	});
}

function exportSO(params) {
	return client.get("api/so/export", {
		params: params,
	});
}

function exportSOAll(params) {
	return client.get("api/so/export-all", {
		params: params,
	});
}

function exportSORoam(params) {
	return client.get("api/so/export-roam", {
		params: params,
	});
}

function exportSOAnually(params) {
	return client.get("api/so/export-data-annually", {
		params: params,
	});
}

function getDetailSO(params) {
	return client.get("api/so/detail", {
		params: {
			so_code : params
		},
	});
}

function getOptionStatus() {
	return client.get("api/options/so-status");
}

function createSO(params) {
	return client.post("api/so/create", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	})
}

function approvalPayment(params) {
	return client.post("api/so/pay", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	})
}

function cancelSO(params) {
	return client.post("api/so/cancel", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	})
}

function deleteSO(params) {
	return client.post("api/so/delete", qs.stringify({
		so_id : params
	}), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	})
}

function approveSO(params) {
	return client.post("api/so/approve", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	})
}

function cancelPaymentSO(params) {
	return client.post("api/so/cancel-paid", qs.stringify({
		so_id : params
	}), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	})
}

function cancelApprovalSO(params) {
	return client.post("api/so/cancel-approved", qs.stringify({
		so_id : params
	}), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	})
}

function getSOApprovalRefund(params) {
	return client.get("api/so/approval_refund", {
		params: params,
	});
}

function approvalRefundPayment(params) {
	return client.post("api/so/refund", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	})
}

function exportSOApprovalRefund(params) {
	return client.get("api/so/export-approval-refund", {
		params: params,
	});
}

export default {
	getSO,
	getSOAnually,
	getSOAll,
	getSORoam,
	exportSO,
	exportSOAll,
	exportSORoam,
	exportSOAnually,
	getDetailSO,
	getOptionStatus,
	createSO,
	approvalPayment,
	cancelSO,
	deleteSO,
	approveSO,
	cancelPaymentSO,
	cancelApprovalSO,
	getSOApprovalRefund,
	approvalRefundPayment,
	exportSOApprovalRefund
};